import * as React from 'react';
import * as ReactDOM from 'react-dom';
const loadScript = require('load-script');
declare var window: any;

const defaultScriptUrl = 'https://cdn.ckeditor.com/4.18.0/standard/ckeditor.js';

export interface IButton {
	name: string;
	settings: CKEDITOR.buttonDefinition;
}

export interface ICommand {
	name: string;
	exec: (edt: any, data?: CKEDITOR.commandDefinition) => boolean;
}

interface IProps {
	isScriptLoaded: boolean;
	config: any;
	scriptUrl: string;
	className: string;
	content: string;
	events: any;
	addButtons?: IButton[];
	addCommands?: ICommand[];
}

/**
 * @author codeslayer1
 * @description CKEditor component to render a CKEditor textarea with defined configs and all CKEditor events handler
 */
class CKEditor extends React.Component<IProps, {}> {
	public unmounting: boolean;
	public editorInstance: CKEDITOR.editor;
	public static defaultProps = {
		content: '',
		config: {},
		isScriptLoaded: false,
		scriptUrl: defaultScriptUrl,
		activeClass: '',
		events: {},
	};

	constructor(props) {
		super(props);

		//Bindings
		this.onLoad = this.onLoad.bind(this);
	}

	//load ckeditor script as soon as component mounts if not already loaded
	public componentDidMount() {
		if (!this.props.isScriptLoaded) {
			loadScript(this.props.scriptUrl, this.onLoad);
		} else {
			this.onLoad();
		}
	}

	public componentWillUnmount() {
		this.unmounting = true;
		if (this.editorInstance) {
			this.editorInstance.destroy();
		}
	}

	public onLoad() {
		if (this.unmounting) {
			return;
		}

		this.setState({
			isScriptLoaded: true,
		});

		if (!window.CKEDITOR) {
			console.error('CKEditor not found');
			return;
		}
		// eslint-disable-next-line react/no-find-dom-node
		this.editorInstance = window.CKEDITOR.appendTo(ReactDOM.findDOMNode(this), this.props.config, this.props.content);

		//Register listener for custom events if any
		for (const event in this.props.events) {
			if (Object.prototype.hasOwnProperty.call(this.props.events, event)) {
				const eventHandler = this.props.events[event];

				this.editorInstance.on(event, eventHandler);
			}
		}
		// add commands
		for (const command of this.props.addCommands || []) {
			this.editorInstance.addCommand(command.name, { exec: command.exec });
		}

		//add buttons
		for (const button of this.props.addButtons || []) {
			this.editorInstance.ui.addButton(button.name, button.settings);
		}

		//Default link target _blank
		window.CKEDITOR.on('dialogDefinition', function (ev) {
			// Take the dialog name and its definition from the event data.
			const dialogName = ev.data.name;
			const dialogDefinition = ev.data.definition;

			if (dialogName === 'link') {
				const targetTab = dialogDefinition.getContents('target');
				// Set the default value for the URL field.
				const targetField = targetTab.get('linkTargetType');
				const targetName = targetTab.get('linkTargetName');
				targetField['default'] = '_blank';
				targetName['default'] = '_blank';
			}
		});
	}

	public render() {
		return <div className={this.props.className} />;
	}
}

export default CKEditor;
